import { useEffect, useState } from "react";

const calc = (end) => Math.max(0, new Date(end).getTime() - Date.now());

export const Countdown = ({ end, big, testId = "countdown" }) => {
  const [ms, setMs] = useState(() => calc(end));
  useEffect(() => {
    const t = setInterval(() => setMs(calc(end)), 1000);
    return () => clearInterval(t);
  }, [end]);
  if (!end) return null;
  if (ms === 0) return <span data-testid={testId} className={`font-bold ${big ? "text-red-600" : ""}`}>انتهى المزاد</span>;
  const s = Math.floor(ms / 1000);
  const parts = [
    [Math.floor(s / 86400), "يوم"], [Math.floor((s % 86400) / 3600), "ساعة"],
    [Math.floor((s % 3600) / 60), "دقيقة"], [s % 60, "ثانية"],
  ];
  if (!big) {
    return <span data-testid={testId} className="tabular-nums" dir="ltr">{parts.map(([v]) => String(v).padStart(2, "0")).join(":")}</span>;
  }
  return (
    <div className="bg-slate-900 text-white rounded-lg p-3 grid grid-cols-4 divide-x divide-x-reverse divide-white/10" data-testid={testId}>
      {parts.map(([v, l]) => (
        <div key={l} className="text-center">
          <div className="text-2xl font-bold font-mono tabular-nums">{String(v).padStart(2, "0")}</div>
          <div className="text-[11px] text-slate-400">{l}</div>
        </div>
      ))}
    </div>
  );
};
